import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

export const Container = styled.div`
  .container {
    max-width: 1446px;
  }
  h2 {
    color: #4c4c4c;

    font-family: 'Source Sans Pro';
    font-size: 19px;
    font-weight: 400;
    margin-bottom: 0px;
  }

  h3 {
    color: #4c4c4c;

    font-family: 'Source Sans Pro';
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 0;
  }
  hr {
    background-color: #f5f3ed;
    height: 2px;
    opacity: 1;
    margin: 34px 0px;
  }

  p {
    color: #000;

    font-family: 'Libre Baskerville';
    font-size: 72px;
    font-weight: 700;
    margin-bottom: 0px;
  }
  .container {
    background-color: #fff;
    border-radius: 34px 34px 0 0;
    margin-top: 80px;
  }

  .btn-new {
    border-radius: 18px;
    border: 2px solid #ffae52;
    color: #000;
    font-family: 'Source Sans Pro';
    font-size: 20px;
    font-weight: 600;
    line-height: 15.5px;
    background: #fff;
    padding: 22px 50px;
  }

  .header-table {
    border-radius: 18px;
    background: linear-gradient(180deg, #f5f3ed 0%, #f5f3ed 100%);
    padding: 19px;
  }

  .row-md-table {
    border-radius: 18px;
    border: 2px solid #e0d9ca;
    padding: 4px;
  }

  .arrow {
    transition-duration: 0.3s;
  }

  .close {
    transform: rotateZ(90deg);
  }

  .totals {
    span {
      color: #4c4c4c;

      font-family: 'Source Sans Pro';
      font-size: 20px;
      font-weight: 400;
    }
  }

  .bg-graph {
    background: linear-gradient(180deg, #faf4e4 0%, #f5f3ed 100%);
    border-radius: 18px;
    padding: 5% 2% 6% 6%;
  }

  .fix {
    position: absolute;
    bottom: 26%;
    left: 0%;
    z-index: 1;
    width: 100%;
    padding: 0 2.5% 0px 6%;
  }

  .bar-opacity {
    width: 1233px;
  }

  .month {
    color: #4e4a44;

    font-family: 'Source Sans Pro';
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 15.5px;
  }

  .zero {
    position: absolute;
    left: 2.5%;
    bottom: 24%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  .half {
    position: absolute;
    left: 1.5%;
    bottom: 53%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  .whole {
    position: absolute;
    left: 1.5%;
    top: 14%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  .graph {
    clip-path: inset(-50px -14px 11px -6px);
  }

  .padding {
    padding: 14px 0px;
  }

  .loan-amount {
    margin-left: calc(50% - 110px);
  }

  @media screen and (min-width: 992px) {
    p {
      font-size: 48px;
    }

    h3 {
      font-size: 20px;
    }

    .row-lg-table {
      border-radius: 18px;
      border: 2px solid #e0d9ca;
      padding: 3px;
    }

    .sub-row-table {
      width: 96.3%;
    }

    .row-md-table {
      border-radius: 18px;
      border: none;
      padding: 0 12px;
    }

    .padding {
      padding: 0px;
    }

    .loan-amount {
      margin-left: 0;
    }
  }
`;

export const Modal = styled(ModalComponent)`
  background: #00000055;

  h2 {
    color: #000;
    font-family: 'Libre Baskerville';
    font-size: 26px;
    font-weight: 700;
  }

  h3 {
    color: #000;

    font-family: 'Source Sans Pro';
    font-size: 16px;
    font-weight: 600;
  }

  input {
    color: #000 !important;

    font-family: 'Source Sans Pro' !important;
    font-size: 20px !important;
    font-weight: 400 !important;
  }

  .modal-content {
    border-radius: 25px;
    background: #fffdfd;
    border: none;
  }

  .bd-input {
    min-height: 56px;
    border-radius: 18px;
    border: 1px solid #e0d9ca;
  }

  .btn-new-contract {
    color: #000;

    text-align: center;
    font-family: 'Roboto';
    font-size: 22px;
    font-weight: 700;
  }

  .btn-submit {
    color: #000;
    font-family: 'Roboto';
    font-size: 22px;
    font-weight: 700;
    border-radius: 18px;
    background: #ffae52;
    padding: 12px;
  }
`;
